<vcl-modal id="termsModal" [modalTitle]="terms.title" *ngIf="terms" [(showModal)]="showModal" [buttonLabels]=" { primary: 'Descargar PDF'} " (modalButtonClick)="toggleModal($event)">
  <p id="pdfText" [innerHtml]="terms.text"></p>
</vcl-modal>

<div class="content-with-filled-button">
  <h2 class="title offset-inline" id="generalTitle">
    {{copyService.copies.identification_pep_sub1_before}}
  </h2>
  <h2 class="sub-title offset-inline" id="generalTitle">
    {{copyService.copies.identification_pep_sub1}}
  </h2>
  <h2 class="sub-title offset-inline" id="generalTitle">
    {{copyService.copies.identification_pep_sub1_1}}
  </h2>
  <h2 class="sub-title offset-inline" id="generalTitle">
    {{copyService.copies.identification_pep_sub1_2}}
  </h2>
  <h2 class="sub-title-black offset-inline" id="generalTitle">
    <strong>{{copyService.copies.identification_pep_sub1_3}}</strong>
  </h2> 
  <br>
  <p class="annotation" *ngFor="let annotation of copyService.copies.annotations">{{annotation}}</p>
  <p class="note">{{copyService.copies.identification_pep_sub2}}</p>
  <div class="content">
    <voxel-radio-button-group id="isPEP" class="radio-margin">
      <voxel-radio-button *ngFor="let selectionList of listIsPEP" [id]="'radioButtonID' + selectionList.label" radioName="pep" [checked]="selectionList.checked" (radioButtonChange)="selectPEP($event)" [value]="selectionList.label">{{selectionList.label}}</voxel-radio-button>
    </voxel-radio-button-group>
  </div>
  <div class="space"></div>
  <div class="terminos">
    <div class="content-info">
      <em class="icon icon-itaufonts_informacao"></em>
      <p class="bottom-text" id="indicationPep">
        {{ copyService.copies.identification_pep_terms }}
      </p>
    </div>
    <div class="line"></div>
  </div>
  <div class="content-info" *ngIf="postLogin === true" >
    <div class="checkbox">
      <voxel-checkbox [id]="'backDocCheckboxTerms'" [label]="checkboxTerms.label" [checked]="checkboxTerms.checked" name="terms" [value]="checkboxTerms.value" (checkboxChange)="checkboxChange($event)">
      </voxel-checkbox>
    </div>
    <div class="content-info">
      <div class="link mb-sm-4">
        <vcl-link [linkId]="'backDocTermsLink'"(click)="toggleModal($event)" [label]="copyService.copies.back_document_link_label">
        </vcl-link>
      </div>
    </div>
  </div>
</div>
<app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.identification_pep_button" [nextDisabled]="isBtnDisabled" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
